import axios from "axios";
import "./App.css";
import "semantic-ui-css/semantic.min.css";
import { useState, useEffect } from "react";
import Device from "./Components/Device";
import Icon from "./Components/Icon";
import Keypad from "./Components/Keypad";
import { useIdleTimer } from "react-idle-timer";

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [screenHidden, hideScreen] = useState(false);
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  const isKiosk =
    params.get("kioskMode") !== "undefined" ? params.get("kioskMode") : false;

  const displayTimeout =
    params.get("displayTimeout") !== null
      ? parseInt(params.get("displayTimeout"))
      : 0;

  //let screenTimeout;
  // const setupScreenTimeout = () => {
  //   if (displayTimeout > 0) {
  //     console.log(`Setting up timeout for ${displayTimeout} seconds`);
  //     clearTimeout(screenTimeout);
  //     screenTimeout = setTimeout(() => {
  //       //document.querySelector("timeout").classList.add("timeout-show");
  //       console.log("Hiding screen...");
  //       hideScreen(true);
  //     }, displayTimeout * 1000);
  //   }
  // };
  // const hideScreenTimeout = () => {
  //   //document.querySelector("timeout").classList.remove("timeout-show");
  //   setupScreenTimeout();
  //   hideScreen(false);
  //   // if (displayTimeout > 0) {
  //   //   screenTimeout = setTimeout(() => {
  //   //    // document.querySelector("timeout").classList.add("timeout-show");
  //   //    hideScreen(true);
  //   //   }, displayTimeout * 100);
  //   // }
  // };

  const timer = useIdleTimer({
    timeout: displayTimeout * 1000 + 1,
    onIdle: () => {
      console.log("idle");

      hideScreen(true);
    },

    onActive: () => {
      console.log("active");
      setTimeout(() => {
        hideScreen(false);
      }, 500);
    },
  });
  useEffect(() => {
    if (displayTimeout < 1) timer.pause();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (authenticated) {
        console.log("Authenticated, checking for update...");
        axios.get("/api/status/last").then((data) => {
          if (!data.data.auth) setAuthenticated(false);
          console.log(data);

          console.log(data.data.doorStatus);
          if (data.data.doorStatus) processDoorStatus(data.data.doorStatus);
          if (data.data.alarmStatus) processAlarmStatus(data.data.alarmStatus);
          setConsoleOutput(
            "Last Updated: \nDoors - " + data.data.doorLastUpdate
              ? data.data.doorLastUpdate
              : "No Update \nAlarm - " + data.data.alarmLastUpdate
              ? data.data.alarmLastUpdate
              : "No Update"
          );
        });
      } else {
        console.log("Not Authenticated yet...");
      }
    }, 60000);
    return () => clearInterval(interval);
    //refresh();
    //setInterval(refresh, 3000);
  }, [authenticated]);

  const doorStatusCodes = { S: 0, O: 1, U: 2 };
  const alarmStatusCodes = { Y: 1, N: 0, U: 2 };
  const [d3Loading, setD3Loading] = useState(false);
  const [d4Loading, setD4Loading] = useState(false);
  const [a1Loading, setA1Loading] = useState(false);
  const [a2Loading, setA2Loading] = useState(false);
  const [consoleOutput, setConsoleOutput] = useState("");

  const [doors, setDoors] = useState([
    {
      Door: "D03",
      DoorName: "734 WEST ENTRY  ",
      DoorStatus: "U",
    },
    {
      Door: "D04",
      DoorName: "734 EAST ENTRY  ",
      DoorStatus: "U",
    },
  ]);
  const [alarms, setAlarms] = useState([
    {
      Alarm: "01",
      AlarmName: "PERIMETER       ",
      AlarmStatus: "U",
    },
    {
      Alarm: "02",
      AlarmName: "INTERIOR        ",
      AlarmStatus: "U",
    },
  ]);
  const processDoorStatus = (doors) => {
    let r = [];
    let c = 0;
    doors.forEach((d) => {
      if (d.Door === "D03" || d.Door === "D04") {
        r.push(d);
        c++;
      }
    });
    if (c > 1) setDoors(r);
  };
  const processAlarmStatus = (alarms) => {
    let r = [];
    let c = 0;
    alarms.forEach((a) => {
      if (a.Alarm === "01" || a.Alarm === "02") {
        r.push(a);
        c++;
      }
    });
    if (c > 1) setAlarms(r);
  };

  const checkAuth = (auth) => {
    //console.log("Code entered: " + code);
    // axios.get("/api/auth/" + auth).then((data) => {
    //   console.log(data);
    //   if (data.data.auth) {
    //     setAuthenticated(true);
    //   } else {
    //     // do something with bad password
    //   }
    // });
    if (typeof auth === "boolean") {
      if (!auth) setAuthenticated(false);
    }
  };

  const checkSessionAuth = (auth) => {
    //console.log("Code entered: " + code);
    axios.get("/api/auth/" + auth).then((data) => {
      console.log(data);
      if (data.data.auth) {
        setAuthenticated(true);
        apiGetStatus();
      } else {
        // do something with bad password
      }
    });
  };

  const apiGetStatus = async () => {
    setConsoleOutput("Getting Status...");
    setD3Loading(true);
    setD4Loading(true);
    setA1Loading(true);
    setA2Loading(true);
    await axios.get("/api/status").then((data) => {
      console.log(data);
      console.log(data.data.doorStatus);
      if (data.data.doorStatus) processDoorStatus(data.data.doorStatus);
      if (data.data.alarmStatus) processAlarmStatus(data.data.alarmStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD3Loading(false);
    setD4Loading(false);
    setA1Loading(false);
    setA2Loading(false);
  };
  const apiLockWest = async () => {
    setConsoleOutput("Locking West Door...");
    setD3Loading(true);
    console.log("Locking West door");
    await axios.get("/api/lock/west").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processDoorStatus(data.data.doorStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD3Loading(false);
  };
  const apiLockEast = async () => {
    setConsoleOutput("Locking East Door...");
    setD4Loading(true);
    console.log("Locking East door");
    await axios.get("/api/lock/east").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processDoorStatus(data.data.doorStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD4Loading(false);
  };
  const apiUnlockWest = async () => {
    setConsoleOutput("Unlocking West Door...");
    setD3Loading(true);
    console.log("Unlocking West door");
    await axios.get("/api/unlock/west").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processDoorStatus(data.data.doorStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD3Loading(false);
  };
  const apiUnlockEast = async () => {
    setConsoleOutput("Unlocking East Door...");
    setD4Loading(true);
    console.log("Unlocking East door");
    await axios.get("/api/unlock/east").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processDoorStatus(data.data.doorStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD4Loading(false);
  };

  const apiUnlockBoth = async () => {
    setConsoleOutput("Unlocking East & West Door...");
    setD4Loading(true);
    setD3Loading(true);
    console.log("Unlocking East & West door");
    await axios.get("/api/unlock/both").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processDoorStatus(data.data.doorStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD4Loading(false);
    setD3Loading(false);
  };

  const apiLockBoth = async () => {
    setConsoleOutput("Locking East & West Door...");
    setD4Loading(true);
    setD3Loading(true);
    console.log("Locking East & West door");
    await axios.get("/api/lock/both").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processDoorStatus(data.data.doorStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setD4Loading(false);
    setD3Loading(false);
  };

  const apiArmPerimeter = async () => {
    if (window.confirm("Are you sure you want to arm the Perimeter?")) {
      setA1Loading(true);
      console.log("Arming Perimeter...");
      setConsoleOutput("Arming Perimeter...");
      await axios.get("/api/arm/perimeter").then((data) => {
        checkAuth(data.data.auth);
        console.log(data);
        processAlarmStatus(data.data.alarmStatus);
        if (data.data.login && data.data.logout && !data.data.panelLocked)
          setConsoleOutput("Success.");
        else
          setConsoleOutput(
            "Failed. " + (data.data.error != null) && data.data.error
          );
      });
      setA1Loading(false);
    } else {
      setConsoleOutput("Arming Perimeter cancelled by user.");
    }
  };
  const apiArmMotion = async () => {
    if (window.confirm("Are you sure you want to arm the Motion sensors?")) {
      console.log("Arming Motion...");
      setConsoleOutput("Arming Motion...");
      setA2Loading(true);
      await axios.get("/api/arm/motion").then((data) => {
        checkAuth(data.data.auth);
        console.log(data);
        processAlarmStatus(data.data.alarmStatus);
        if (data.data.login && data.data.logout && !data.data.panelLocked)
          setConsoleOutput("Success.");
        else
          setConsoleOutput(
            "Failed. " + (data.data.error != null) && data.data.error
          );
      });
      setA2Loading(false);
    } else {
      setConsoleOutput("Arming Motion sensors cancelled by user.");
    }
  };
  const apiDisarmPerimeter = async () => {
    console.log("Disarm Perimeter...");
    setConsoleOutput("Disarming Perimeter...");
    setA1Loading(true);

    await axios.get("/api/disarm/perimeter").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processAlarmStatus(data.data.alarmStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setA1Loading(false);
  };
  const apiDisarmMotion = async () => {
    console.log("Disarm Motion...");
    setConsoleOutput("Disarming Motion...");

    setA2Loading(true);
    await axios.get("/api/disarm/motion").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processAlarmStatus(data.data.alarmStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setA2Loading(false);
  };
  const apiArmBoth = async () => {
    if (window.confirm("Are you sure you want to arm the whole system?")) {
      console.log("Arming both alarms...");
      setConsoleOutput("Arming Perimeter & Motion...");
      setA1Loading(true);
      setA2Loading(true);
      await axios.get("/api/sarm/both").then((data) => {
        checkAuth(data.data.auth);
        console.log(data);
        processAlarmStatus(data.data.alarmStatus);
        if (data.data.login && data.data.logout && !data.data.panelLocked)
          setConsoleOutput("Success.");
        else
          setConsoleOutput(
            "Failed. " + (data.data.error != null) && data.data.error
          );
      });
      setA1Loading(false);
      setA2Loading(false);
    } else {
      setConsoleOutput("Arming whole system cancelled by user.");
    }
  };
  const apiDisarmBoth = async () => {
    console.log("Disarming Both alarms...");
    setConsoleOutput("Disarming Perimeter & Motion...");
    setA1Loading(true);
    setA2Loading(true);
    await axios.get("/api/disarm/both").then((data) => {
      checkAuth(data.data.auth);
      console.log(data);
      processAlarmStatus(data.data.alarmStatus);
      if (data.data.login && data.data.logout && !data.data.panelLocked)
        setConsoleOutput("Success.");
      else
        setConsoleOutput(
          "Failed. " + (data.data.error != null) && data.data.error
        );
    });
    setA1Loading(false);
    setA2Loading(false);
  };
  const onCodeEneteredHandler = async (code) => {
    checkSessionAuth(code);
  };
  // (async () => {
  //   await (async () => {
  //     axios.get("/api/session_auth/").then((data) => {
  //       console.log(data);
  //       if (data.data.auth) {
  //         setAuthenticated(true);
  //       } else {
  //         // do something with bad password
  //       }
  //     });
  //   })();
  // })();

  if (!authenticated) {
    return (
      <div className={isKiosk ? "App kiosk-mode" : "App"}>
        <div
          className={screenHidden ? "timeout  timeout-show" : "timeout"}
        ></div>
        <div className="AppBody">
          <Keypad onCodeEntered={onCodeEneteredHandler}></Keypad>
        </div>
      </div>
    );
  } else {
    return (
      <div className={isKiosk ? "App kiosk-mode" : "App"}>
        <div
          className={screenHidden ? "timeout timeout-show" : "timeout"}
        ></div>
        <div className="AppBody">
          <div className="DeviceGroup">
            <div className="groupLabel" key="dc">
              Doors
            </div>
            <div className="grid">
              {doors.length > 1 &&
                doors.map((door, x) => {
                  return (
                    <>
                      <Device
                        key={"d" + x}
                        Name={door.DoorName.replace(
                          "734 WEST ENTRY",
                          "West Door (Kids Hall)"
                        ).replace("734 EAST ENTRY", "East Door (Octagon)")}
                        Status={doorStatusCodes[door.DoorStatus]}
                        Activate={
                          door.Door === "D03" ? apiLockWest : apiLockEast
                        }
                        Deactivate={
                          door.Door === "D03" ? apiUnlockWest : apiUnlockEast
                        }
                        Loading={door.Door === "D03" ? d3Loading : d4Loading}
                        Type="Door"
                      ></Device>
                    </>
                  );
                })}
              <div className="small_container double">
                <div className="style small" onClick={apiLockBoth}>
                  <Icon icon="Lock" color="red" />
                  <div>Lock</div>
                </div>
                <div className="style small" onClick={apiUnlockBoth}>
                  <Icon icon="Lock" color="green" />
                  <div>Unlock</div>
                </div>
              </div>
            </div>
          </div>
          <div className="DeviceGroup">
            <div className="groupLabel">Alarm</div>

            <div className="grid">
              {alarms.length > 1 &&
                alarms.map((alarm, x) => {
                  return (
                    <>
                      <Device
                        key={"a" + x}
                        Name={alarm.AlarmName.replace(
                          "PERIMETER       ",
                          "Perimeter"
                        ).replace("INTERIOR        ", "Motion Sensors")}
                        Status={alarmStatusCodes[alarm.AlarmStatus]}
                        Activate={
                          alarm.Alarm === "01" ? apiArmPerimeter : apiArmMotion
                        }
                        Deactivate={
                          alarm.Alarm === "01"
                            ? apiDisarmPerimeter
                            : apiDisarmMotion
                        }
                        Loading={alarm.Alarm === "01" ? a1Loading : a2Loading}
                        Type="Alarm"
                      ></Device>
                    </>
                  );
                })}

              <div className="small_container double">
                <div className="style small" onClick={apiArmBoth}>
                  <Icon icon="led" color="red" /> <div>Arm</div>
                </div>
                <div className="style small" onClick={apiDisarmBoth}>
                  <Icon icon="led" color="green" />
                  <div>Disarm</div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid">
            <div className="output double">
              <code>{consoleOutput}</code>
            </div>
            <div className="double button refresh style" onClick={apiGetStatus}>
              <Icon icon="Refresh" size="35" />
            </div>

            {isKiosk && (
              <div
                className="button double style refresh-page"
                onClick={() => {
                  window.location.reload();
                }}
              >
                <Icon icon="Lock" size="30"></Icon>
                <div>Lock Screen</div>
              </div>
            )}
          </div>
          {/* <div className="row">
          <button onClick={apiLockWest}>Lock West Door</button>
        </div>
        <div className="row">
          <button onClick={apiLockEast}>Lock East Door</button>
        </div>
        <div className="row">
          <button onClick={apiUnlockWest}>Unlock West Door</button>
        </div>
        <div className="row">
          <button onClick={apiUnlockEast}>Unlock East Door</button>
        </div> */}
        </div>
      </div>
    );
  }
}

export default App;
